import { NgModule } from '@angular/core';

import { OrderTypeForConfirmationModule } from './forConfirmation';

const toExport = [
    OrderTypeForConfirmationModule
];

@NgModule({
    imports: [
        ...toExport
    ],
    exports: [
        ...toExport
    ],
})
export class OrderTypesModule { }
